import useCountdown from '@/hooks/useCountDown';
import useTranslation from 'next-translate/useTranslation';
import { twMerge } from 'tailwind-merge';

const CountDownLabel: React.FC<{
  start?: number | string;
  end?: number | string;
  status: 'begoing' | 'ongoing';
  className?: string;
}> = props => {
  const { t } = useTranslation('home');
  const { timeString } = useCountdown(() => props.end as number, {
    start: () => props.start as number,
    onEnd: () => {
      window.location.reload();
    }
  });
  if (timeString) {
    if (props.status === 'ongoing') {
      return (
        <div
          data-testid={`wid-product-card-lightning-${props.status}`}
          className="absolute top-[10px] left-2.5 h-[18px] leading-5 rounded-200 flex items-center border-2 border-white border-solid bg-pricing-bg px-1 py-0 enki-body-3xs-strong text-pricing-fg">
          {timeString}
        </div>
      );
    }
    if (props.status === 'begoing') {
      return (
        <div
          data-testid={`wid-product-card-lightning-${props.status}`}
          className={twMerge(
            'rounded-lg flex items-center px-2 py-0 mt-1.5 enki-body-2xs-medium text-highlight-txt',
            props.className
          )}>
          {t('begins_in', { timeString: timeString })}
        </div>
      );
    }
  }
  return null;
};

export default CountDownLabel;
